// CogniEvaManage.js
import React, { useState } from "react";
import CogniHistorial from "./cogniHistorial";
import CogniRecommendation from "./CogniRecommendation";
//import "./CogniEvaManage.css"; // Sigue cargando tus estilos habituales
import original from "../Patient/list/PatientTable"
import {useLocation,Navigate} from "react-router-dom";

const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000
};

const modalStyle = {
    backgroundColor: "#fff",
    borderRadius: "8px",
    width: "320px",
    maxWidth: "90%",
    padding: "24px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
    position: "relative"
};

const closeBtnStyle = {
    position: "absolute",
    top: "8px",
    right: "12px",
    background: "transparent",
    border: "none",
    fontSize: "18px",
    cursor: "pointer"
};

const testBtnStyle = {
    width: "100%",
    padding: "12px",
    margin: "8px 0",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer"
};

const CogniEvaManage = () => {
    const [activeTab, setActiveTab] = useState("formulario");
    const [showModal, setShowModal] = useState(false);

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const handleConcentrationTest = () => {
        // Aquí iría la lógica para lanzar el test de concentración.
        console.log("Iniciando test de concentración...");
        // Por ejemplo, podrías redirigir o llamar a otro componente.
        handleCloseModal();
    };

    const handleMemoryTest = () => {
        // Aquí iría la lógica para lanzar el test de memoria.
        console.log("Iniciando test de memoria...");
        handleCloseModal();
    };
    const  {state} = useLocation();
    const { nombre, edad, id } = state || {};

    if (!id) return <Navigate to="/" replace />;

    return (
        <div className="cogni-container">
            {/* ======== HEADER PRINCIPAL ======== */}
            <header className="cogni-header">
                <h1 className="cogni-header__title">Evaluación Cognitiva Integrada</h1>
                <p className="cogni-header__subtitle">Valoración para inclusión en historial médico</p>
            </header>

            {/* ======== BARRA DE INFORMACIÓN DEL PACIENTE ======== */}
            <div>
                <h1>Evaluación Cognitiva</h1>
                <p><strong>Nombre:</strong> {nombre}</p>
                <p><strong>Edad:</strong> {edad} años</p>
                <p><strong>ID:</strong> {id}</p>
                {/* … */}
            </div>

            {/* ======== PESTAÑAS ======== */}
            <nav className="cogni-tabs">
                <button
                    className={activeTab === "formulario" ? "cogni-tab cogni-tab--active" : "cogni-tab"}
                    onClick={() => setActiveTab("formulario")}
                >Formulario de evaluación</button>
                <button
                    className={activeTab === "resultados" ? "cogni-tab cogni-tab--active" : "cogni-tab"}
                    onClick={() => setActiveTab("resultados")}
                >Resultados anteriores</button>
                <button
                    className={activeTab === "recomendaciones" ? "cogni-tab cogni-tab--active" : "cogni-tab"}
                    onClick={() => setActiveTab("recomendaciones")}
                >Recomendaciones</button>
            </nav>

            {/* ======== CONTENIDO DE PESTAÑAS ======== */}
            <section className="cogni-tab-content">
                {/* ===== FORMULARIO ===== */}
                {activeTab === "formulario" && (
                    <div className="cogni-form-wrapper">
                        {/* Información importante */}
                        <div className="cogni-info-box">
                            <p className="cogni-info-box__title">Información importante</p>
                            <p className="cogni-info-box__text">
                                Este formulario es una pre-evaluación para determinar si el paciente se beneficiaría de una evaluación cognitiva completa con CogniFit. Los resultados se integrarán automáticamente en su historial médico.
                            </p>
                        </div>

                        {/* Sección: Información general */}
                        <fieldset className="cogni-section">
                            <legend className="cogni-section__title">Información general</legend>

                            <div className="cogni-form-row">
                                <label htmlFor="motivo" className="cogni-label">Motivo principal de la evaluación</label>
                                <select id="motivo" className="cogni-select">
                                    <option value="">Seleccionar...</option>
                                    <option value="memoria">Problemas de memoria</option>
                                    <option value="atencion">Dificultad de atención</option>
                                    <option value="otros">Otros</option>
                                </select>
                            </div>

                            <div className="cogni-form-row cogni-form-row--inline">
                                <label className="cogni-label--inline">¿Evaluación previa con CogniFit?</label>
                                <div className="cogni-radio-group">
                                    <label><input type="radio" name="previa" value="si"/> Sí</label>
                                    <label><input type="radio" name="previa" value="no" defaultChecked/> No</label>
                                </div>
                            </div>

                            <div className="cogni-form-row">
                                <label htmlFor="observaciones" className="cogni-label">Observaciones adicionales</label>
                                <textarea id="observaciones" className="cogni-textarea" placeholder="Información relevante para contextualizar la evaluación" rows={4}/>
                            </div>
                        </fieldset>

                        {/* Sección: Evaluación inicial */}
                        <fieldset className="cogni-section">
                            <legend className="cogni-section__title">Evaluación inicial</legend>

                            <div className="cogni-form-row">
                                <p className="cogni-label">Dificultades reportadas por el paciente (seleccione todas las aplicables)</p>
                                <div className="cogni-checkbox-grid">
                                    {[
                                        "Memoria a corto plazo","Memoria a largo plazo","Atención/Concentración",
                                        "Lenguaje/Comunicación","Orientación","Toma de decisiones",
                                        "Habilidades visoespaciales","Velocidad de procesamiento"
                                    ].map(texto=>(<label key={texto}><input type="checkbox"/> {texto}</label>))}
                                </div>
                            </div>

                            <div className="cogni-form-row">
                                <div className="cogni-form-col" style={{ maxWidth: 300 }}>
                                    <label htmlFor="duracion" className="cogni-label">Duración de los síntomas</label>
                                    <select id="duracion" className="cogni-select">
                                        <option value="">Seleccionar...</option>
                                        <option value="1_4_semanas">1-4 semanas</option>
                                        <option value="1_6_meses">1-6 meses</option>
                                        <option value="mas_6_meses">Más de 6 meses</option>
                                    </select>
                                </div>
                                <div className="cogni-form-col" style={{ marginTop: 24 }}>
                                    <label className="cogni-label">Impacto en actividades diarias</label>
                                    <input type="range" min="0" max="100" defaultValue="50" className="cogni-range"/>
                                    <div className="cogni-range-labels"><span>Sin impacto</span><span>Impacto moderado</span><span>Impacto severo</span></div>
                                </div>
                            </div>
                        </fieldset>

                        {/* Sección: Factores relacionados */}
                        <fieldset className="cogni-section">
                            <legend className="cogni-section__title">Factores relacionados</legend>

                            <div className="cogni-form-row">
                                <p className="cogni-label">¿Hay factores que puedan estar influyendo? (seleccione todas las aplicables)</p>
                                <div className="cogni-checkbox-grid">
                                    {[
                                        "Estrés","Ansiedad","Depresión","Problemas de sueño",
                                        "Medicación","Lesión cerebral","Uso de sustancias","Ninguno conocido"
                                    ].map(texto=>(<label key={texto}><input type="checkbox"/> {texto}</label>))}
                                </div>
                            </div>

                            <div className="cogni-form-row">
                                <label htmlFor="cambios" className="cogni-label">Cambios recientes en la vida del paciente</label>
                                <textarea id="cambios" className="cogni-textarea" placeholder="Cambios importantes en el último año (trabajo, familia, salud, etc.)" rows={3}/>
                            </div>
                        </fieldset>

                        {/* Botón que abre el modal */}
                        <div style={{ marginBottom: '16px' }}>
                            <button
                                className="cogni-btn cogni-btn--cogni"
                                style={{ width: '100%', padding: '16px 0' }}
                                onClick={handleOpenModal}
                            >🧠 Iniciar evaluación completa con CogniFit</button>
                        </div>

                        {/* Botones finales (Guardar a la izquierda, Enviar a la derecha) */}
                        <div className="cogni-buttons" style={{ justifyContent: 'space-between' }}>
                            <button className="cogni-btn cogni-btn--secondary">Guardar borrador</button>
                            <button className="cogni-btn cogni-btn--primary">Enviar evaluación</button>
                        </div>
                    </div>
                )}

                {activeTab === "resultados" && <CogniHistorial />}
                {activeTab === "recomendaciones" && <CogniRecommendation />}
            </section>

            {/* ======== MODAL POP-UP ======== */}
            {showModal && (
                <div style={overlayStyle}>
                    <div style={modalStyle}>
                        <button style={closeBtnStyle} onClick={handleCloseModal} aria-label="Cerrar">&times;</button>
                        <h2 style={{ marginTop: 0 }}>Selecciona un test</h2>
                        <button
                            style={{ ...testBtnStyle, backgroundColor: "#e0f7fa" }}
                            onClick={handleConcentrationTest}
                        >
                            Test de concentración
                        </button>
                        <button
                            style={{ ...testBtnStyle, backgroundColor: "#fce4ec" }}
                            onClick={handleMemoryTest}
                        >
                            Test de memoria
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CogniEvaManage;
